import axios from 'axios';
import Cookies from 'quasar/src/plugins/Cookies.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import { StatusCode } from './httpStatusCode'; 

import router from "@/router/index.js"; // I assume you have router module

function handleResponse(response){
    return response;
}


function handleError({response}){
    const { status } = response;
    if(status == StatusCode.UNAUTHORIZED){
        router.push({name: 'login'});
        return null;
    }

    if(status == StatusCode.NOT_FOUND){
        router.push({name: 'notFound'});
        return null;
    } 
    return response;
}

function getToken() {
    // 1. Cookie "user" (login normal)
    if (Cookies.has("user")) {
        const u = Cookies.get("user");
        if (u) {
            const parsed = typeof u === 'string' ? JSON.parse(u) : u;
            if (parsed?.message) {
                console.log('🔑 Token from cookie user:', parsed.message.substring(0, 20) + '...');
                return parsed.message;
            }
        }
    }
    // 2. localStorage fallback (login guardado) - Quasar usa .has() no .hasItem()
    if (LocalStorage.has("user")) {
        const u = LocalStorage.getItem("user");
        if (u) {
            const parsed = typeof u === 'string' ? JSON.parse(u) : u;
            if (parsed?.message) {
                console.log('🔑 Token from localStorage user:', parsed.message.substring(0, 20) + '...');
                return parsed.message;
            }
        }
    }
    // 3. Cookie "token" (cuentas vencidas)
    if (Cookies.has("token")) {
        console.log('🔑 Token from cookie token');
        return Cookies.get("token");
    }
    console.warn('⚠️ No token found in cookie/localStorage');
    console.log('Cookies:', document.cookie);
    console.log('localStorage user:', localStorage.getItem('user'));
    return null;
}

export function postRequest(endpoint, data, config = null) {
    const token = getToken();
    let body = token ? { token, ...data } : { ...data };
    return axios.post(endpoint, JSON.stringify(body), config ?? {}).then(handleResponse).catch(handleError);
}

export function postRequestFormData(endpoint, datos){
    const formData = new FormData();
    const token = getToken();
    if (token) {
        formData.append("token", token);
    }
    const keys = Object.keys(datos);
    keys.map(key =>{
        formData.append(key, datos[key]);
    })
    return axios.post(endpoint, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then(handleResponse)
}